<template>
    <li class="list-group-item">
        <div class="form-group d-flex justify-content-between align-items-center m-0">
            <div class="m-0 min-width"><p class="m-0"><i v-if="icon !== ''" :class="icon" class="fad"></i>{{ icon
                ? ' '
                : '' }}{{ label !== '' ? label : '' }}</p></div>
            <div class="w-100 ml-3">
                <p class="m-0 text-right">{{ text }}</p>
            </div>
        </div>
    </li>
</template>

<script>
export default {
    name: 'OpeningListItem',
    props: {
        label: String,
        text: String,
        icon: String,
    },
};
</script>

<style scoped>
.min-width {
    min-width: 30px;
}
</style>
